import { Link } from 'react-router-dom';
import { INFO_CARDS } from '../utils/homeData.js';
import { withBasePath } from '../utils/paths.js';

export default function AirportInformation() {
  return (
    <section className="py-16 sm:py-20" id="information">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="v4-reveal mb-10 flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-nkc-gold">Airport information</p>
            <h2 className="mt-2 font-display text-3xl font-bold text-nkc-navy sm:text-4xl">
              Plan every step of your journey
            </h2>
          </div>
          <Link to="/information" className="text-sm font-bold text-nkc-blue hover:underline">
            Information hub →
          </Link>
        </div>
        <div className="grid gap-5 lg:grid-cols-3">
          {INFO_CARDS.map((card) => (
            <article
              key={card.title}
              className="v4-reveal rounded-3xl border border-nkc-blue/10 bg-white p-7 shadow-soft"
            >
              <div className="mb-5 h-40 overflow-hidden rounded-2xl">
                <img src={withBasePath(card.image)} alt="" className="h-full w-full object-cover" loading="lazy" />
              </div>
              <h3 className="font-display text-xl font-bold text-nkc-navy">{card.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-nkc-muted">{card.description}</p>
              {card.links ? (
                <div className="mt-5 flex flex-wrap gap-2">
                  {card.links.map((link, idx) => (
                    <Link
                      key={link.to}
                      to={link.to}
                      className={
                        idx === 0
                          ? 'inline-flex rounded-full bg-nkc-blue px-5 py-2.5 text-sm font-bold text-white hover:bg-nkc-navy'
                          : 'inline-flex rounded-full border border-nkc-blue/20 bg-white px-5 py-2.5 text-sm font-bold text-nkc-blue hover:bg-nkc-mist'
                      }
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              ) : (
                <Link
                  to={card.to}
                  className="mt-5 inline-flex rounded-full bg-nkc-blue px-5 py-2.5 text-sm font-bold text-white hover:bg-nkc-navy"
                >
                  {card.ctaLabel}
                </Link>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
